import { render, staticRenderFns } from "./CommentUserProfileActions.vue?vue&type=template&id=f71a4066&"
import script from "./CommentUserProfileActions.vue?vue&type=script&lang=js&"
export * from "./CommentUserProfileActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports